'use strict';
'use es6';

// Browser does not support service workers.

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNSUPPORTED = exports.UNSUPPORTED = 'UNSUPPORTED';

// Unable to create a valid service worker installer.
var INVALID = exports.INVALID = 'INVALID';

// Service worker installation is currently pending.
var INSTALLING = exports.INSTALLING = 'INSTALLING';

// The latest service worker version is already installed.
var INSTALLED = exports.INSTALLED = 'INSTALLED';